import Modal from "../Modal/Modal";
import useCountryConfigHook from "@/shared/hooks/useCountryConfigHook";

const CourierPrivacyModal = () => {
  const { locale } = useCountryConfigHook();

  return (
    <Modal className="overflow-hidden">
      <iframe
        className="w-full h-svh"
        src={`/documents/privacy-policy-${locale}.pdf`}
      />
    </Modal>
  );
};
export default CourierPrivacyModal;
